import { useRef } from "react";

import styled from "styled-components";

import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";

import FnrButtonWrapper from "UI/FnrButtonWrapper";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTappyShrink from "UI/FnrTappyShrink";
import { colors } from "UI/colors";

import { useGetBackgroundColorData } from "../../API/queryHooks";

export default function LoginButton() {
  const { setActiveContentKey, setVerticallyCenterLogin } =
    useMemberToolbarStore();
  const { accentColor } = useGetBackgroundColorData();

  const buttonRef = useRef();

  const handleLoginButtonClick = () => {
    setActiveContentKey(contentKeys.login);
    setVerticallyCenterLogin(true);
  };

  return (
    <StyledButtonWrapper
      $accentColor={accentColor}
      onClick={handleLoginButtonClick}
      ref={buttonRef}
      type="button"
    >
      <FnrTappyShrink>
        <LoginButtonContent>
          <ButtonText $color={accentColor}>Login</ButtonText>
          <SFnrContainedIcon
            color={accentColor}
            size="md"
            icon="fa-sign-in fas"
          />
        </LoginButtonContent>
      </FnrTappyShrink>
    </StyledButtonWrapper>
  );
}

const StyledButtonWrapper = styled(FnrButtonWrapper)`
  background-color: ${colors.transparent};
  padding: 8px 4px 8px 14px;
  border-radius: 20px;
  height: 40px;
  transition: background-color 300ms ease-in-out, box-shadow 300ms ease-in-out;

  &:hover:not(:disabled) {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

const LoginButtonContent = styled.div`
  display: flex;
  align-items: center;
  padding-right: 4px;
`;

const SFnrContainedIcon = styled(FnrContainedIcon)`
  transform: translateY(1px);
`;

const ButtonText = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: ${({ $color }) => $color};
`;
